import React from 'react';
import './DisappearingNotification.scss';
import AppContext from '../../../AppContext';

export type DisappearingNotificationType = {
  message: string
  transactionTime?: number
  top?: number
  bottom?: number
  left?: number
  right?: number
  useAbsolute?: boolean
}

interface Props {
  message: string
  transactionTime?: number
  top?: number
  bottom?: number
  left?: number
  right?: number
}

export const DisappearingNotification: React.FC<Props> = ({
  message,
  bottom,
  left,
  right,
  top,
  transactionTime = 0.3,
}) => {
  const appContext = React.useContext(AppContext);
  const setDisappearingNotification = appContext?.setDisappearingNotification;
  const [isActive, setIsActive] = React.useState(false);

  React.useEffect(() => {
    setIsActive(true);
    const hideId = window.setTimeout(() => setIsActive(false), 2500);
    const clearId = window.setTimeout(() => {
      setDisappearingNotification?.(undefined);
    }, 3500);

    return () => {
      window.clearTimeout(hideId);
      window.clearTimeout(clearId);
    };
  }, [message, setDisappearingNotification]);

  return (
    <div
      className={`disappearingNotification${appContext?.disappearingNotification?.useAbsolute ? ' disappearingNotificationAbs' : ''}${isActive ? ' disappearingNotificationActive' : ''}`}
      style={{
        top: top != null ? `${top}%` : undefined,
        bottom: bottom != null ? `${bottom}%` : undefined,
        left: left != null ? `${left}%` : undefined,
        right: right != null ? `${right}%` : undefined,
        transition: `opacity ${transactionTime}s ease`,
      }}
    >
      {message}
    </div>
  );
};
